






























import {
  Component,
  Vue,
} from 'vue-property-decorator';
import { mixins } from 'vue-class-component';

import LargeNavbar from './LargeNavbar.vue';
import Logo from './Logo';
import SmallNavbar from './SmallNavbar.vue';

import { WithAppContext } from '@/mixins';

@Component({
  components: {
    LargeNavbar,
    SmallNavbar,
  },
  props: {
    logo: {
      type: Object as () => Logo,
      required: true,
    },
  },
})
export default class Header extends mixins(WithAppContext) {
  get showLargeNavbar() {
    return !this.isMobile;
  }

  get hasFixedNavbar() {
    // Navbar is only fixed at the top when on large screens/
    return this.showLargeNavbar &&
      // Page with fixed top nav should set `meta.withFixedTopNav`. See `src/router/index.ts`.
      ('withFixedTopNav' in this.$route.meta) &&
      (this.$route.meta.withFixedTopNav === true);
  }
}
